import type { ReactNode } from 'react';

export function AuthLayout({ title, subtitle, children }: { title: string; subtitle?: string; children: ReactNode }) {
  return (
    <div className="grid min-h-screen place-items-center bg-bg px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-7 flex items-center justify-center gap-2">
          <img src="/logo-mark.png" alt="" className="h-7 w-7 rounded-[22%]" />
          <span className="font-display text-lg font-bold italic tracking-tight text-ink">WrapForce</span>
        </div>
        <div className="rounded-[var(--radius-card)] border border-border bg-surface p-7 shadow-sm">
          <h1 className="font-display text-xl font-bold text-ink">{title}</h1>
          {subtitle ? <p className="mt-1 text-sm text-muted">{subtitle}</p> : null}
          <div className="mt-6">{children}</div>
        </div>
      </div>
    </div>
  );
}

export function AuthAlert({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-[var(--radius-input)] border border-danger/30 bg-danger/10 px-3.5 py-2.5 text-sm text-danger">
      {children}
    </div>
  );
}
